import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import {AllPolymerLayouts} from 'constants/MapsConstants';
import TooltipBarGraph from 'molbio/maps/linear/TooltipBarGraph';
import Range from 'molbio/maps/selectables/Range';
import getTestProps from 'test/lib/cypress/getTestProps';

interface VotesProps {
  layout: AllPolymerLayouts['votes'];
  rangeModel: Range;
  sequence: GapSequenceWrapper;
  votes: Array<number>;
  xFn: (index: number) => number;
}

export default function Votes({layout, rangeModel, sequence, votes, xFn}: VotesProps): JSX.Element {
  const rangeStart = Math.max(Math.floor(rangeModel.start()), 0);
  const rangeEnd = Math.min(Math.floor(rangeModel.end()), sequence.length());

  return (
    <g {...getTestProps({component: 'Votes', element: 'root'})}>
      <TooltipBarGraph
        values={votes.slice(rangeStart, rangeEnd)}
        maxValue={votes.reduce((acc, curr) => Math.max(acc, curr), 0)}
        maxHeight={layout.svgHeight}
        xFn={(index: number) => xFn(rangeStart + index)}
        tooltipDelay={{show: 300, hide: 0}}
        getFormattedTooltipTitle={(value) => `Votes: ${value}`}
        baselineProps={{
          fill: 'gray',
          fillOpacity: 1,
          stroke: 'black',
          strokeOpacity: 1,
        }}
        onClickCallback={(index: number) => {
          const offsetIndex = rangeStart + index;
          sequence.selection().setEndpoints(offsetIndex, offsetIndex + 1);
        }}
        barRectProps={{
          className: css(styles.voteBar),
          fill: 'gray',
          stroke: 'black',
          strokeOpacity: 1,
          strokeWidth: 0.5,
        }}
      />
    </g>
  );
}

const styles = StyleSheet.create({
  voteBar: {
    cursor: 'pointer',
    ':hover': {fill: '#4D4D4D'},
  },
});
